// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorPage_wrapper__1yoJZ","links":"ErrorPage_links__wwOMe","image":"ErrorPage_image__4C__P","recWrapper":"ErrorPage_recWrapper__qLGuU"};